import { render, staticRenderFns } from "./InvoicingView.vue?vue&type=template&id=2f3356d4"
import script from "./InvoicingView.vue?vue&type=script&lang=js"
export * from "./InvoicingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports